import { orderBySection } from './src/orderBySection';

fbErrors.$inject = ['fbErrorsService'];

export default function fbErrors(fbErrorsService) {
  return {
    restrict: 'E',
    template: `
      <div ec-layout>
        <ec-toolbar>
          <label ec-ellipsis>{{::'ieces.errors_panelFormTitle'|translate}}</label>
        </ec-toolbar>
        <main label="list"></main>
      </div>
    `,
    scope: true,
    link,
  };

  function link(scope, element) {
    const elem = element[0];
    const render = renderErrorsListFactory(elem.querySelector('[label="list"]'));
    const api = { render }; // DEPRECATED
    elem.render = render;
    //
    elem.addEventListener('click', onClick);

    scope.$on('$destroy', () => {
      elem.removeEventListener('click', onClick);
    });

    setTimeout(() => elem.dispatchEvent(new CustomEvent('fbErrors:ready', { detail: api }))); // DEPRECATED

    ////////////////////////////////////////////////////////////////////////////

    function onClick(event) {
      const { section, model, indexes } = event.target.dataset;
      if (!section || !model) {
        return;
      }

      elem.dispatchEvent(
        new CustomEvent('fbErrors:flash', {
          detail: { section, model, indexes: indexes.split(',') },
        })
      );
    }

    function renderErrorsListFactory(container) {
      return errors => {
        const errorsBySections = orderBySection(errors);
        const detail = Object.keys(errorsBySections).reduce((acc, cur) => {
          acc[cur] = errorsBySections[cur].counter;
          return acc;
        }, {});
        elem.dispatchEvent(new CustomEvent('fbErrors:counters', { detail }));
        fbErrorsService.render(errorsBySections).then(html => {
          container.innerHTML = html;
        });
      };
    }
  }
}
